import { UniqueIssuesData } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';
import { ScoreData } from 'src/apps/dashboard/services/queries/score/helpers/transformResults';

import {
	AccessibilitySummaryData,
	createDefaultAccessibilitySummary
} from './accessibilityHelpers';
import { createMetric, getAccessibilityStatus } from './calculationHelpers';

export const transformAccessibilityData = (
	scoreData?: ScoreData[],
	uniqueIssuesData?: UniqueIssuesData,
	totalIssuesData?: UniqueIssuesData
): AccessibilitySummaryData => {
	// Return default values if no data is available
	if (!scoreData && !uniqueIssuesData && !totalIssuesData) {
		return createDefaultAccessibilitySummary();
	}

	let score: number | null = null;
	if (scoreData && scoreData.length > 0) {
		const { score: latestScore } = scoreData[scoreData.length - 1];
		score = latestScore;
	}

	const defaultStatus = getAccessibilityStatus(0);

	// Use actual unique issues data if available, otherwise use defaults
	const uniqueIssuesCurrent = uniqueIssuesData?.current ?? 0;
	const uniqueIssuesPrevious = uniqueIssuesData?.previous ?? 0;
	const uniqueCriticalCurrent = uniqueIssuesData?.critical?.current ?? 0;
	const uniqueCriticalPrevious = uniqueIssuesData?.critical?.previous ?? 0;

	// Use actual total issues data if available, otherwise use defaults
	const totalIssuesCurrent = totalIssuesData?.current ?? 0;
	const totalIssuesPrevious = totalIssuesData?.previous ?? 0;
	const totalCriticalCurrent = totalIssuesData?.critical?.current ?? 0;
	const totalCriticalPrevious = totalIssuesData?.critical?.previous ?? 0;

	return {
		groupedScore: {
			score: score === null ? null : Math.round(score),
			status: score === null ? defaultStatus : getAccessibilityStatus(score)
		},
		uniqueIssues: {
			critical: createMetric(uniqueCriticalCurrent, uniqueCriticalPrevious),
			allIssues: createMetric(uniqueIssuesCurrent, uniqueIssuesPrevious)
		},
		totalIssues: {
			critical: createMetric(totalCriticalCurrent, totalCriticalPrevious),
			allIssues: createMetric(totalIssuesCurrent, totalIssuesPrevious)
		}
	};
};
